import { useMediaQuery } from "react-responsive";

export default function Comments() {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  return (
    <div>
      {isTabletOrMobile ? (
        <div className="account-ruls">
          برای اطلاع‌دادن «مشکل، انتقاد، پیشنهاد یا حذف حساب‌ کاربری برای همیشه»
          کافی است درخواست خود از طریق ایمیل به آدرس طلایی‌شو ارسال کنید. آدرس
          طلایی‌شو:
          <br />
          <u>talaeshow@gmail.com</u>
        </div>
      ) : (
        <div>
          <div className="header-for-comments-desktop">
            انتقادات ،پیشنهادات و ثبت شکایات
          </div>
          <div className="content-for-comments-desktop">
            در صورت بروز هرگونه مشکل هنگام خرید و فروش اینترنتی یا درخواست پاک
            نمودن حساب کاربری خود و پیشنهاد جهت بهبود روند کاری با پشتیبانی تماس
            گرفته و یا از طریق ایمیل talaeshow@gmail.com ارتباط برقرار کنید.
          </div>
        </div>
      )}
    </div>
  );
}
